<template>
    <div class="page">
    <router-link :to="{name:'registry.schedule'}"  class="headText">Расписание</router-link> <span class="headText"> / </span> <span style="text-decoration: underline;" class="headText">Список записей</span>
    <button @click="toUpdateSlot()" class="vm-button" style="display: flex; margin-left:auto"> Записать</button>
    <div class="vm-card vm-card-toolbar">
      <div class="schedule-tooltip">
        <div class="doctor-selector">
          <div class="headtitle">Список пациентов записавшихся на:
            <b-form-datepicker
          v-model="currentDay"
          button-variant="info"
          locale="ru-RU"
          start-weekday="1"
          :hide-header="true"
          :appendToBody="true"
          @shown="shown"
          @input="getListQueue($event, $event)"
          :calendar-width="calendarWidth"
          style="width:40%"
        ></b-form-datepicker>
          <searchInput v-model="searchPatient" style="height:35px; width:auto" />
        </div>
        <transition name="fade">
          <ul class="specialities_list">
            <template v-if="!loading && patients.length > 0">
            <li class="special_item" v-for="patient in patients"  v-bind:key="patient.id">
              <div class="special" :class="{selected: patient === cur_patient}" @click="cur_patient=patient">
                <span class="count">{{ patient.start_time.slice(-8, -3) }} - {{ patient.end_time.slice(-8, -3) }}</span>
                <span class="fio">{{ patient.patient.lastName }} {{ patient.patient.firstName }} {{ patient.patient.middleName }}</span>
                <span class="phone">{{ patient.patient.phone }}</span>
                <span class="doctor">{{ patient.doctor.employee.last_name }} {{ patient.doctor.employee.first_name }} {{ patient.doctor.employee.middle_name }} / {{ patient.doctor.specialty.title }}</span>
                <div class="actions">
                  <span @click="toCardPatient(patient.patient)" v-b-tooltip.hover title="карта пациента" class="material-icons" style="cursor:pointer; color: dodgerblue; opacity: 0.6">assignment</span>
                  <span @click="showConfirmation = true" v-b-tooltip.hover title="отменить запись"  class="material-icons" style="cursor:pointer; color: red; opacity:0.6">remove_circle</span>

                </div>
              </div>
              <Dialog v-model="showConfirmation">
                <template>
                  <div class="vm-header">
                  <span>Удалить запись?</span>
                </div>
                <div class="vm-content">
                  Вы действительно хотите удалить запись {{ patient.patient.lastName }} {{ patient.patient.firstName }} {{ patient.patient.middleName }} на {{ patient.start_time.slice(-8, -3) }} - {{ patient.end_time.slice(-8, -3) }}?
                </div>
                <div class="footer-bottom">
                  <b-button @click="removeSlot(patient.id)" variant="info" style="margin-right:5px">Да</b-button>
                  <b-button @click="showConfirmation = false" style="margin-left:5px">Нет</b-button>
                </div>
                </template>
              </Dialog>
            </li>
            </template>
            <template v-else>
            <div v-if="loading">
              <b-skeleton style="height:45px"></b-skeleton>
              <b-skeleton style="height:45px"></b-skeleton>
              <b-skeleton style="height:45px"></b-skeleton>
              <b-skeleton style="height:45px"></b-skeleton>
              <b-skeleton style="height:45px"></b-skeleton>
            </div>
            </template>
            <div v-if="!loading && !patients.length > 0" class="empty-list">
                Записей нет...
            </div>
          </ul>
        </transition>
        </div>
      </div>
    </div>
    <Dialog v-model="showDoctors">
        <template>
          <div class="vm-header"> Записать к </div>
          <div class="vm-content">
          <v-select
                placeholder="Выберите доктора..."
                v-model="doctor"
                :options="doctors"
                :appendToBody="true"
                label="name"
                @keyup.native="searchDoctor($event.target.value)"
              >
                <template #selected-option="{ name, department, specialty }">
                  <span class="name">{{ name }}</span>
                  <span class="more">({{ department }} / {{ specialty }})</span>
                </template>
                <template #option="{ name, department, specialty }">
                  <div class="option-subtitle">
                    {{ department }} / {{ specialty }}
                  </div>
                  <div class="option-title">{{ name }}</div>
                </template>
                <template v-slot:no-options="{ search, searching }">
                    <template v-if="searching">
                        Не найдено: <em>{{ search }}</em>.
                    </template>
                    <em style="opacity: 0.5;" v-else>Начните набирать...</em>
                </template>
              </v-select>
              <div class="footer-bottom">
                  <b-button v-if="doctor" @click="chooseDoctor()" variant="info">Открыть расписание</b-button>
                </div>
          </div>
        </template>
    </Dialog>
    </div>    
</template>

<script>
import searchInput from '@app/components/uikit/searchInput';
import Dialog from '@app/components/uikit/Dialog';
import { timetableApi, doctorApi } from '@app/services';
import toastr from 'toastr';
import { BIconNutFill } from 'bootstrap-vue';


export default {
  components: {
    searchInput,
    Dialog
  },
    data() {
        return {
            patients: [],
            cur_patient:'',
            searchPatient: '',
            currentDay: new Date(),
            calendarWidth: '250px',
            loading: false,
            showConfirmation: false,
            showDoctors: false,
            doctors: [],
            doctor: '',
            timeout: ''

        };
    },

    methods: {
      shown() {
        this.calendarWidth = document.getElementsByClassName('dropdown b-form-datepicker')[0].clientWidth - 15 + 'px';
      },
      getListQueue(begin, out) {
        this.loading = true;
        const format = 'YYYY-MM-DD';
        const start = moment(begin).format(format);
        const end = moment(out).format(format);
        timetableApi.getAllByDay(start, end).then(res => {
          this.patients = res; console.log(this.patients);
        }).catch(error => {
          toastr.error('Ошибка');
        }).finally(fin => {
            this.loading = false;
        });
      },
      toCardPatient(pat) {
        this.$router.push({name: 'registry.patient.card', params: {uuidPatient: pat.id, item: pat, prev: 'registry.queue'}});
      },
      removeSlot(id) {
        const slot = {
        patient: null
      };
      timetableApi.update(id, slot).then(res => {
        this.getListQueue(this.currentDay, this.currentDay);
      }).catch(error => {
        this.$bvToast.toast(error, {
          title: 'Ошибка',
          autoHideDelay: 10000,
          variant: 'danger'
        });
      });
      },
      toUpdateSlot() {
        this.showDoctors = true;
        this.searchDoctor();
        
      },
      async searchDoctor(search) {
         if (this.timeout) clearTimeout(this.timeout); 
                this.timeout = setTimeout(async() => {  
              const { items } = await doctorApi.getAll(null, null, search ? search : null);
              this.doctors = items.map(item => ({
                id: item.id,
                name: `${item.employee.lastName} ${item.employee.firstName} ${item.employee.middleName}`,
                department: item.department.title,
                specialty: item.specialty.title
              }));
             }, 1000);
      },
      chooseDoctor() {
        this.$router.push({name: 'registry.schedule', params: { doctor: this.doctor.id}});
      }
    },
    mounted() {
      const today = new Date();
      this.getListQueue(today, today);
    }
};
</script>

<style lang="scss" scoped>
.vm-card-toolbar {
  padding: 1rem;
  margin-bottom: 1rem;
}
.schedule-tooltip {
  display: flex;
  flex-direction: column;
}
.headText {
  color: #737373; 
  font-size: 1.5rem;
  margin-bottom: 2rem;
  font-weight: 500;
  line-height: 1.2;
  cursor: pointer;
}
.headText:hover {
  color: black;
}
.special {
  display: flex;
  width:100%;
  cursor: auto;
}
.count {
  width:10%;
}
.fio {
  width: 25%;
}
.phone {
  width: 15%
}
.doctor {
  width:30%
}
.actions {
  width: 20%;
  display: flex;
  justify-content: space-around;
}
.vm-header {
  color: #000;
  padding: 2rem;
  font-size: 2rem;
}
.vm-content {
  padding: 2rem;
}
.footer-bottom {
  display:flex;
  justify-content: center;
  margin-bottom: 1rem;
}
.vm-button {
  font-weight: 300;
  background: linear-gradient(to right, #8C30DA, #5C48D4);
  border: 1px solid #dbdbdb;
  border-radius: 25px;
  color: white;
  padding: 0.5rem 3rem;
  transition: all 200ms;
  outline: none;
  text-decoration: none;
}
.vm-button:hover {
  border: 1px solid #6cbdee;
  background-color: #6cbdee;
  color: #000;
  cursor: pointer;
}
::v-deep .dropdown-menu.show {
  transform: none !important;
  top: 35px !important;
}
::v-deep .b-skeleton-text {
  height: 45px;
  border-bottom: 1px solid gray;
  margin-bottom: 0;
}
</style>